import { Input } from "@bootstrap-styled/v4";
import styled from "styled-components";

export const DefaultTextInput = styled(Input)``;
